import Main from '@/views/layouts/main'
import ErrorLimit from '@/views/components/error-limit/index.component'
import PlayerCardModule from '@/views/player-card/player-card.module'

const PlayerCardPage = () => {
  return (
    <Main paddingZero>
      <ErrorLimit>
        <PlayerCardModule />
      </ErrorLimit>
    </Main>
  )
}

export default PlayerCardPage
